import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// By default, this component centers itself in the space given. If you don't want that, specify className accordingly.
export var Spinner = function Spinner(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'subkit-primary' : _ref$color,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'w-full flex justify-center items-center' : _ref$className;
  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: /*#__PURE__*/_jsxs("svg", {
      className: "animate-spin h-5 w-5 self-center text-".concat(color),
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/_jsx("circle", {
        className: "opacity-25",
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        strokeWidth: "4"
      }), /*#__PURE__*/_jsx("path", {
        className: "opacity-75",
        fill: "currentColor",
        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      })]
    })
  });
};